import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { usePageVisibility } from 'sb-hooks'
import { connect } from 'redaction'

import actions from 'redux/actions'


const defaultInterval = 5 * 60 * 60 * 1000 // 5 hours
const pageVisibilityInterval = 60 * 60 * 1000 // 1 hour

// Time when tokens was last fetched
let lastUpdateTime = Date.now()

const updateTokens = () => {
  actions.models.requestTokens.fetch()
    .then(() => {
      lastUpdateTime = Date.now()
    })
}

const onPageVisibilityChange = (isHidden) => {
  const needToFetch = !isHidden && ((Date.now() - lastUpdateTime) > pageVisibilityInterval)

  if (needToFetch) {
    updateTokens()
  }
}

const RequestTokensUpdater = (props) => {
  const { interval, query: { fetchTokens } } = props

  if (fetchTokens) {
    updateTokens()
  }

  useEffect(() => {
    const intervalRef = setInterval(updateTokens, interval)

    return () => {
      clearInterval(intervalRef)
    }
  }, [ interval ])

  usePageVisibility(onPageVisibilityChange)

  return null
}

RequestTokensUpdater.propTypes = {
  interval: PropTypes.number,
}

RequestTokensUpdater.defaultProps = {
  interval: defaultInterval,
}


export default connect({
  query: 'routing.location.query',
})(RequestTokensUpdater)
